import { Alert, AlertDialog, AlertDialogBody, AlertDialogContent, AlertDialogFooter, AlertDialogHeader, AlertDialogOverlay, AlertIcon, Avatar, AvatarBadge, Box, Button, Card, CardBody, Checkbox, Divider, Flex, FormControl, FormLabel, Grid, Heading, Icon, IconButton, Input, InputGroup, InputLeftElement, Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay, Popover, PopoverArrow, PopoverBody, PopoverCloseButton, PopoverContent, PopoverTrigger, Select, Stack, Table, TableContainer, Tbody, Td, Text, Textarea, Th, Thead, Tr, useColorModeValue, useDisclosure, useToast, VStack } from '@chakra-ui/react'
import React, { useCallback, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useStateContext } from '../../context/ContextProvider';
import axiosClient from '../../axios-client';
import { CloseIcon, DeleteIcon, EditIcon, SearchIcon } from '@chakra-ui/icons';
import MyPagination from "../../components/MyPagination";
import { PiPlusBold } from 'react-icons/pi';
import animationData from '../../assets/lotties/subscribe.json'
import Lottie from 'react-lottie';
import { useTranslation } from 'react-i18next';
import makeAnimated from 'react-select/animated';
import MySelect from 'react-select';
import { FaEye, FaPencilAlt } from 'react-icons/fa';
import Resizer from "react-image-file-resizer";
import { DragDropContext, Droppable, Draggable } from "@hello-pangea/dnd";

const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
        preserveAspectRatio: 'xMidYMid slice'
    }
};


function GestPromoCode() {
    const navigate = useNavigate()
    const { user } = useStateContext()
    const { t } = useTranslation();
    const [data, setData] = useState([]);
    const [currentPage, setCurrentPage] = useState(0);
    const [id, setId] = useState(null);
    const toast = useToast()
    const cancelRef = React.useRef()
    const { isOpen, onOpen, onClose } = useDisclosure();
    const [message, setMessage] = useState('');
    const [codePromoData, setCodePromoData] = useState();
    const [price, setPrice] = useState();
    const [name, setName] = useState('');
    const [discount, setDiscount] = useState();
    const [duration, setDuration] = useState('once');
    const [durationInMonths, setDurationInMonths] = useState('');

    const [validFrom, setValidFrom] = useState('');
    const [validTo, setValidTo] = useState('');

    const [code, setCode] = useState('');
    const [promoId, setPromoId] = useState('');
    const [description, setDescription] = useState('');
    const [subscription, setSubscription] = useState();
    const [codeId, setCodeId] = useState(null);


    const [selectedType, setSelectedType] = useState(null);



    //search variable
    const [searchTerm, setSearchTerm] = useState('');

    const [isAlertOpen, setIsAlertOpen] = useState(false);
    const [isPreviewOpen, setIsPreviewOpen] = useState(false);
    const [changeModal, setChangeModal] = useState(true)
    const [isLoading, setIsLoading] = useState(false)

    const onOpenAlert = () => {
        setIsAlertOpen(true);
    };
    const onCloseAlert = () => {
        setIsAlertOpen(false);
    };
    const onOpenPreview = () => {
        setIsPreviewOpen(true);
    };
    const onClosePreview = () => {
        setIsPreviewOpen(false);
    };

    const handleTypeChange = (ev) => {
        setSelectedType(ev.target.value)
    }

    ////////////////////////////////the size of the table//////////////////////////////
    const PAGE_SIZE = 5;
    const [pageSize, setPageSize] = useState(PAGE_SIZE);
    const handlePageSizeChange = (event) => {
        const newSize = parseInt(event.target.value, 10);
        setPageSize(newSize);
        setCurrentPage(0);
    };
    //////////////////////////////////////////////////////////////////////////////////
    const [checkLengthData, setCheckLengthData] = useState(false)
    const [loadingData, setLoadingData] = useState(true)
    const [paginationData, setPaginationData] = useState()

    useEffect(() => {
        axiosClient.get(`/promocodes/?page_size=${pageSize}&page=${currentPage + 1}&search_term=${searchTerm}`)
            .then((response) => {
                let filteredData = response.data.results;
                setPaginationData(response.data);

                if (filteredData.length === 0) {
                    setCheckLengthData(true)
                }
                else {
                    setData(filteredData);
                }
                setLoadingData(false)
            })
            .catch((error) => {
                // console.error(error);
                setLoadingData(false)

            });

    }, [searchTerm, currentPage, pageSize])

    function update() {
        axiosClient.get(`/promocodes/?page_size=${pageSize}&page=${currentPage + 1}&search_term=${searchTerm}`)
            .then((response) => {
                let filteredData = response.data.results;
                setPaginationData(response.data);

                if (filteredData.length === 0) {
                    setCheckLengthData(true)
                }
                else {
                    setData(filteredData);
                }
                setLoadingData(false)
            })
            .catch((error) => {
                // console.error(error);
                setLoadingData(false)

            });

    }

    const handleDelete = (id) => {
        if (!id) return;
        axiosClient.delete(`/promocodes/delete/${id}/`)
            .then((response) => {
                setData((prevData) => prevData.filter((row) => row.id !== id));
                toast({
                    description: t("Le code promo est supprimé avec succès"),
                    status: 'success',
                    variant: 'left-accent',
                    duration: 2000,
                    isClosable: true,
                    position: 'bottom-right'
                })
            })
            .catch((error) => {
                // console.error(error);
            });
        onCloseAlert()
    }

    const AjoutPromoCode = async () => {
        if (!name || !code || !discount || !validTo || !duration) {
            setMessage(t("Veuillez remplir tous les champs obligatoires"));
            return;
        }
        
        if (duration && duration==="repeating" && !durationInMonths)
        {
            setMessage(t("Durée manquante en mois pour la durée répétitive"));
            return;
        }
        setIsLoading(true)
        try {
            const formData = new FormData();
            formData.append("code", code);
            formData.append("influencer_name", name);
            formData.append("discount", discount);

            formData.append("duration", duration);
            if (duration === 'repeating' && durationInMonths) {
                formData.append("duration_in_months", durationInMonths);
            }
            // formData.append("valid_from", validFrom);
            formData.append("valid_to", validTo);

            axiosClient.post('/promocodes/create/', formData)
                .then((response) => {
                    toast({
                        description: 'Code promo ajouté avec succès.',
                        status: 'success',
                        duration: 3000,
                        isClosable: true,
                        position: "bottom-right",
                        variant: "left-accent"
                    });
                    update();
                    onClose();
                    setName('');
                    setCode('');
                    setValidTo('');
                    setDiscount();
                    setDuration('once')
                    setMessage('');
                    setIsLoading(false)
                })
                .catch((err) => {
                    const response = err.response;
                    if (response && response.status === 400 && response.data.code) {
                        // If the error is due to a duplicate promo code
                        toast({
                            // title: "Erreur",
                            description: "Ce code promo existe déjà.",
                            status: "error",
                            duration: 3000,
                            isClosable: true,
                            position: "bottom-right",
                            variant: "left-accent"
                        });
                        setIsLoading(false)
                    } else {
                        // Other errors
                        toast({
                            // title: "Erreur",
                            description: "Une erreur s'est produite lors de l'ajout du code promo.",
                            status: "error",
                            duration: 3000,
                            isClosable: true,
                            position: "bottom-right",
                            variant: "left-accent"
                        });
                        setIsLoading(false)
                    }
                });
        } catch (error) {

            toast({
                // title: "Erreur",
                description: "Une erreur s'est produite lors de l'ajout du code promo.",
                status: "error",
                duration: 3000,
                isClosable: true,
                position: "bottom-right",
                variant: "left-accent"
            });
            setIsLoading(false)
        }
    };


    const UpdatePromoCode = async (id) => {
        setIsLoading(true)
        try {
            const formData = new FormData();
            if (code) formData.append("code", code);
            if (name) formData.append("influencer_name", name);
            if (discount) formData.append("discount", discount);
            // if (validFrom) formData.append("valid_from", validFrom);
            if (validTo) formData.append("valid_to", validTo);

            axiosClient.put(`/promocodes/update/${id}/`, formData)
                .then((response) => {
                    toast({
                        description: 'Code promo modifié avec succès.',
                        status: 'success',
                        duration: 3000,
                        isClosable: true,
                        position: "bottom-right",
                        variant: "left-accent"
                    });
                    update();
                    onClose();
                    setName('');
                    setCode('');
                    setValidTo('');
                    setDiscount();
                    setMessage('');
                    setIsLoading(false)
                })
                .catch((err) => {
                    const response = err.response;
                    console.log(response);

                    if (response && response.status === 400 && response.data.code) {
                        // Handle duplicate promo code error
                        toast({
                            // title: "Erreur",
                            description: "Ce code promo existe déjà.",
                            status: "error",
                            duration: 3000,
                            isClosable: true,
                            position: "bottom-right",
                            variant: "left-accent"
                        });
                        setIsLoading(false)
                    } else {
                        // Handle other errors
                        console.log(response);

                        toast({
                            // title: "Erreur",
                            description: "Une erreur s'est produite lors de la mise à jour du code promo.",
                            status: "error",
                            duration: 3000,
                            isClosable: true,
                            position: "bottom-right",
                            variant: "left-accent"
                        });
                        setIsLoading(false)
                    }
                });

        } catch (error) {
            toast({
                // title: "Erreur",
                description: "Une erreur s'est produite lors de la mise à jour du code promo.",
                status: "error",
                duration: 3000,
                isClosable: true,
                position: "bottom-right",
                variant: "left-accent"
            });
            setIsLoading(false)
        }
    };


    const bgCard = useColorModeValue("white", "gray.800")
    const cardBorder = useColorModeValue("gray.200", "gray.600")
    const textColor = useColorModeValue("gray.600", "gray.400")

    return (
        <Box>

            <Flex>
                <Box w="100%" display={"flex"} justifyContent="space-between" flexDirection={{ base: 'column', md: "row" }} mt={2} mb={{ base: 0, md: 5 }}>
                    <Text fontFamily='Plus Jakarta Display' as="cite" fontSize={{ base: "18px", md: "20px", lg: "25px" }} color="gray"><span onClick={() => navigate('/')} style={{ cursor: 'pointer' }} onMouseEnter={e => e.target.style.textDecoration = "underline"} onMouseLeave={e => e.target.style.textDecoration = "none"} >{t("Accueil")}</span>  / <span>{t("Codes Promo")}</span> </Text>
                    <Button color={"white"} bgGradient='linear(to-r, #eb6921, #fa8d51)' _hover={{ bgGradient: 'linear(to-r, #eb6921,#eb6921)' }} mb={{ base: 5, md: 0 }} onClick={() => {
                        onOpen()
                        setChangeModal(true)
                    }}
                        leftIcon={<PiPlusBold />} variant='solid'
                    >
                        {t("Ajouter code promo")}
                    </Button>
                </Box>

            </Flex>

            <Flex
                align={'center'}
                justify={'center'}
            >

                <Stack
                    w={'full'}
                    maxW='full'
                    bg={useColorModeValue('white', 'gray.700')}
                    rounded={'lg'}
                    p={6}
                    my={5}>
                    <Flex
                        mb={4}
                        justifyContent="end"
                        alignItems="center"
                        direction={{ base: 'column', lg: 'row' }}
                    >


                        <InputGroup size="sm" w={{ base: '100%', lg: "40%" }}>
                            <InputLeftElement
                                pointerEvents='none'
                                children={<SearchIcon color='gray.300' />}
                            />
                            <Input
                                borderRadius="5"
                                placeholder={t("Recherche...")}
                                value={searchTerm}
                                onChange={(e) => {
                                    setCurrentPage(0)
                                    setSearchTerm(e.target.value)
                                }}
                                mb={4}
                                sx={{
                                    marginLeft: 'auto',
                                }}
                            />  </InputGroup>

                    </Flex>
                    <TableContainer >
                        <Table size={"sm"} >
                            <Thead>
                                <Tr>
                                    <Th fontFamily='Plus Jakarta Display'>{t('Code')}</Th>
                                    <Th fontFamily='Plus Jakarta Display'>Nom</Th>
                                    <Th fontFamily='Plus Jakarta Display' fontSize="12">{t("Remise")}</Th>
                                    {/* <Th fontFamily='Plus Jakarta Display'>Ajoutée par</Th> */}
                                    <Th fontFamily='Plus Jakarta Display'>{t("Date de création")}</Th>
                                    <Th fontFamily='Plus Jakarta Display'>{t("Valable jusqu'au")}</Th>
                                    {/* <Th fontFamily='Plus Jakarta Display'>Historique</Th> */}

                                    <Th fontFamily='Plus Jakarta Display'>Options</Th>
                                </Tr>
                            </Thead>
                            <Tbody>
                                {paginationData?.length !== 0 ? (
                                    data.map((row, index) => (
                                        <Tr p={0} key={row.id}>
                                            <Td>{row.code}</Td>
                                            <Td>{row.influencer_name || "unknown"}</Td>
                                            <Td>{row.discount}%</Td>
                                            <Td>

                                                {new Date(row.creation_date).toLocaleString("fr-FR", {
                                                    month: "2-digit",
                                                    day: "2-digit",
                                                    year: "numeric",
                                                    hour: "2-digit",
                                                    minute: "2-digit",

                                                    hour12: false,
                                                })}
                                            </Td>
                                            <Td>{new Date(row.valid_to).toLocaleString("fr-FR", {
                                                month: "2-digit",
                                                day: "2-digit",
                                                year: "numeric",
                                                hour: "2-digit",
                                                minute: "2-digit",

                                                hour12: false,
                                            })}</Td>
                                            <Td>
                                                <Button
                                                    size="sm"
                                                    onClick={() => {
                                                        setCodePromoData(row);
                                                        setChangeModal(false);
                                                        onOpen();
                                                        setPromoId(row.id);
                                                    }}

                                                    variant={'outline'}
                                                    colorScheme='yellow'

                                                    leftIcon={<EditIcon />}>
                                                    {t("Modifier")}
                                                </Button>

                                                {(user.role === "SUPERADMIN" || user.role === "ADMIN") && <Button
                                                    ml={5}
                                                    size="sm"
                                                    onClick={() => {
                                                        setCodeId(row.id);
                                                        onOpenAlert();
                                                    }}
                                                    colorScheme='red'
                                                    leftIcon={<DeleteIcon />}>
                                                    {t("Supprimer")}
                                                </Button>
                                                }

                                            </Td>
                                        </Tr>
                                    ))
                                ) : (
                                    !searchTerm &&
                                    (<Tr>
                                        <Td colSpan={8}>{t("il n'y a pas encore de données.")}</Td>
                                    </Tr>)
                                )}
                                {(((searchTerm) && paginationData?.length === 0) || (checkLengthData)) && (
                                    <Tr>
                                        <Td colSpan={8}>{t("Aucune ligne correspondante n'a été trouvée.")}</Td>
                                    </Tr>

                                )}
                            </Tbody>
                        </Table>
                    </TableContainer>
                    <Flex flexDirection={{ base: 'column', lg: "row" }} justify="space-between" align="center" w="100%">
                        <Box flex="1">
                            <MyPagination
                                paginationData={paginationData}
                                currentPage={currentPage}
                                setCurrentPage={setCurrentPage}
                                PAGE_SIZE={pageSize}
                            />
                        </Box>

                        <Select w="70px" value={pageSize} onChange={handlePageSizeChange}>
                            <option value="10">10</option>
                            <option value="20">20</option>
                            <option value="30">30</option>
                            <option value="40">40</option>
                            <option value="50">50</option>
                            {/* Add more options as needed */}
                        </Select>
                    </Flex>
                </Stack>

            </Flex>


            <AlertDialog
                isOpen={isAlertOpen}
                leastDestructiveRef={cancelRef}
                onClose={onCloseAlert}
            >
                <AlertDialogOverlay>
                    <AlertDialogContent>
                        <AlertDialogHeader fontSize='lg' fontWeight='bold'>
                            {t("Supprimer")}
                        </AlertDialogHeader>

                        <AlertDialogBody>
                            {t("êtes-vous sûr ? Vous ne pourrez pas annuler cette action ultérieurement.")}
                        </AlertDialogBody>

                        <AlertDialogFooter>
                            <Button ref={cancelRef} onClick={onCloseAlert}>
                                {t("Annuler")}
                            </Button>
                            <Button onClick={() => handleDelete(codeId)} colorScheme='red' ml={3}>
                                {t("Supprimer")}
                            </Button>
                        </AlertDialogFooter>
                    </AlertDialogContent>
                </AlertDialogOverlay>
            </AlertDialog>
            {changeModal ?
                <Modal size={"xl"} isOpen={isOpen} onClose={() => {
                    onClose();
                    setDiscount()
                    setMessage('');
                    setDuration('once')
                    setDurationInMonths('')
                    setValidTo('')
                }}>
                    <ModalOverlay />
                    <ModalContent>
                        <ModalHeader>{t("Ajout de code promo")}</ModalHeader>
                        <ModalCloseButton />
                        <ModalBody pb={6}>
                            {message &&
                                <Alert mb={2} fontSize={"sm"} padding={2} variant={"left-accent"} status='error' rounded="md">
                                    <AlertIcon />
                                    {message}
                                </Alert>
                            }
                            <Flex flexDirection={'column'} align={'center'}>
                                <Flex w="100%" flexDirection={'column'}>
                                    <FormControl isRequired mb={3}>
                                        <FormLabel>{t("Code promo")}</FormLabel>
                                        <Input maxLength={50} name="code" onChange={e => setCode(e.target.value)} placeholder={t("Code promo")} />
                                    </FormControl>
                                    <FormControl isRequired mb={3}>
                                        <FormLabel>{t("Nom d'influenceur")}</FormLabel>
                                        <Input maxLength={50} name="name" onChange={e => setName(e.target.value)} placeholder={t("Nom d'influenceur")} />
                                    </FormControl>

                                    <FormControl isRequired mb={3}>
                                        <FormLabel>{t("Remise")}</FormLabel>
                                        <Input value={discount} type='number' maxLength={50} name="discount"
                                            onChange={e => setDiscount(e.target.value)}
                                            // onChange={e => {
                                            //     const value = e.target.value;
                                            //     if (value > 70) {
                                            //       setDiscount(70); 
                                            //     } else {
                                            //       setDiscount(value); 
                                            //     }
                                            //   }} 
                                            placeholder={t("La remise (%)")} />
                                    </FormControl>
                                    <FormControl mb={3}>
                                        <FormLabel>{t("Durée de la remise")}</FormLabel>
                                        <Select
                                            // placeholder={t("Sélectionnez une durée")}
                                            onChange={(e) => setDuration(e.target.value)}
                                        >
                                            <option value="once">{t("Une fois")}</option>
                                            <option value="repeating">{t("Répétitif")}</option>
                                            <option value="forever">{t("Permanent")}</option>
                                        </Select>
                                    </FormControl>
                                    {duration === 'repeating' && (
                                        <FormControl isRequired mb={3}>
                                            <FormLabel>{t("Durée en mois")}</FormLabel>
                                            <Input
                                                type="number"
                                                min={1}
                                                value={durationInMonths}
                                                onChange={(e) => setDurationInMonths(e.target.value)}
                                                placeholder={t("Nombre de mois")}
                                            />
                                        </FormControl>
                                    )}


                                    {/* <FormControl isRequired mb={3}>
                                        <FormLabel>Valable à partir du</FormLabel>
                                        <Input
                                            type="datetime-local"
                                            value={validFrom}
                                            onChange={(e) => setValidFrom(e.target.value)}
                                            placeholder="Sélectionnez une date"
                                        />
                                    </FormControl> */}
                                    <FormControl isRequired>
                                        <FormLabel>valable jusqu'au</FormLabel>
                                        <Input
                                            type="datetime-local"
                                            value={validTo}
                                            onChange={(e) => setValidTo(e.target.value)}
                                            placeholder="Sélectionnez une date"
                                        />
                                    </FormControl>

                                </Flex>
                            </Flex>
                        </ModalBody>
                        <ModalFooter>
                            {(!code || !name || !discount || !validTo || !duration)
                                ? <Button colorScheme='blue' isDisabled>{t("Ajouter")}</Button>
                                : <Button
                                    isLoading={isLoading}
                                    isDisabled={isLoading}
                                    colorScheme='blue' onClick={AjoutPromoCode}>{t("Ajouter")}</Button>
                            }
                        </ModalFooter>
                    </ModalContent>
                </Modal>

                :
                <Modal size={"xl"} isOpen={isOpen} onClose={() => {
                    onClose();
                    setCode('')
                    setMessage('');

                }}>
                    <ModalOverlay />

                    <ModalContent>
                        <ModalHeader>{t("Modification de code promo")}</ModalHeader>
                        <ModalCloseButton />
                        <ModalBody pb={6}>
                            {message && (
                                <Alert mb={2} fontSize={"sm"} padding={2} variant={"left-accent"} status='error' rounded="md">
                                    <AlertIcon />
                                    {message}
                                </Alert>
                            )}
                            <Flex flexDirection={'column'} align={'center'}>
                                <Flex w="100%" flexDirection={'column'}>
                                    <FormControl isRequired mb={3}>
                                        <FormLabel>{t("Code promo")}</FormLabel>
                                        <Input defaultValue={codePromoData?.code} maxLength={50} name="code" onChange={e => setCode(e.target.value)} placeholder={t("Code promo")} />
                                    </FormControl>
                                    <FormControl isRequired mb={3}>
                                        <FormLabel>{t("Nom d'influenceur")}</FormLabel>
                                        <Input defaultValue={codePromoData?.influencer_name} maxLength={50} name="name" onChange={e => setName(e.target.value)} placeholder={t("Nom d'influenceur")} />
                                    </FormControl>

                                    <FormControl mb={3}>
                                        <FormLabel>{t("Remise")}</FormLabel>
                                        <Input disabled defaultValue={codePromoData?.discount} maxLength={50} name="remise"
                                            onChange={e => setDiscount(e.target.value)}
                                            // onChange={e => {
                                            //     const value = e.target.value;
                                            //     if (value > 70) {
                                            //       setDiscount(70); 
                                            //     } else {
                                            //       setDiscount(value); 
                                            //     }
                                            //   }} 
                                            placeholder={t("La remise (%)")} />
                                    </FormControl>
                                    {/* <FormControl  mb={3}>
                                        <FormLabel>Valable à partir du</FormLabel>
                                        <Input
                                        disabled
                                            type="datetime-local"
                                            defaultValue={codePromoData?.valid_from ? new Date(codePromoData.valid_from).toISOString().slice(0, 16) : ""}
                                            onChange={(e) => setValidFrom(e.target.value)}
                                            placeholder="Sélectionnez une date"
                                        />
                                    </FormControl> */}
                                    <FormControl >
                                        <FormLabel>valable jusqu'au</FormLabel>
                                        <Input
                                            disabled
                                            type="datetime-local"
                                            defaultValue={codePromoData?.valid_to ? new Date(codePromoData.valid_to).toISOString().slice(0, 16) : ""}
                                            onChange={(e) => setValidTo(e.target.value)}
                                            placeholder="Sélectionnez une date"
                                        />
                                    </FormControl>
                                </Flex>
                            </Flex>
                        </ModalBody>
                        <ModalFooter>
                            <Button
                                colorScheme='blue'
                                onClick={() => UpdatePromoCode(promoId)}
                                isLoading={isLoading}
                                isDisabled={isLoading}
                            >
                                {t("Modifier")}
                            </Button>
                        </ModalFooter>
                    </ModalContent>
                </Modal>

            }


        </Box>
    )
}

export default GestPromoCode